import { render, staticRenderFns } from "./SignatureUploader.vue?vue&type=template&id=49185fa6&scoped=true&"
import script from "./SignatureUploader.vue?vue&type=script&lang=js&"
export * from "./SignatureUploader.vue?vue&type=script&lang=js&"
import style0 from "./SignatureUploader.vue?vue&type=style&index=0&id=49185fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49185fa6",
  null
  
)

export default component.exports